import { ComponentAlignment, PieChart } from '@makyoapp/makyo-tw-ui'

import { LayoutDemo } from './LayoutDemo'

export const PieChartDemo = () => {
  const compSettings = {
    alignment: 'parent' as ComponentAlignment,
    backgroundColor: 'primary-90' as any,
    data: [
      { name: 'Apple', value: 10 },
      { name: 'Banana', value: 20 },
      { name: 'Cherry', value: 30 },
      { name: 'Date', value: 40 },
      { name: 'Elderberry', value: 50 },
      { name: 'Fig', value: 60 },
      { name: 'Grape', value: 70 },
      { name: 'Honeydew', value: 80 },
      { name: 'Kiwi', value: 90 },
      { name: 'Lemon', value: 100 },
    ],
    dataKey: 'value',
    isDonut: false,
    nameKey: 'name',
    sequenceType: 'sequential' as 'random' | 'sequential' | undefined,
    showLabel: false,
    showLegend: true,
    showTooltip: true,
    width: '100%',
  }
  return (
    <LayoutDemo title='Pie Chart' bgColor='var(--color-primary-90)'>
      <div className='w-full h-full flex items-center justify-center'>
        <PieChart {...compSettings} />
      </div>
    </LayoutDemo>
  )
}
